import React, { useState, useEffect } from 'react';

import { GetCourseById } from './requests/CourseRequests';


const CourseInvite = ({ courseId }) => {
    const [course, setCourse] = useState();

    useEffect(() => {
        getCourse();
    }, [getCourse]);

    async function getCourse() {
        setCourse(await GetCourseById(courseId));
    }
    
    
    return (
        <div>
            {course?.name}
            </div>
    );
};

export default CourseInvite;

